import { useContext } from 'react'

import { Box, Text } from '@fairfashion/design-system'

import { GlobalDataContext } from '../../../../contexts/globalData'
import { docMask } from '../../../../utilities/masks/brasilianDocuments'

import * as Styles from './provider-data.styles'
import { ProviderDataProps } from './provider-data.types'

export const ProviderData = ({ provider }: ProviderDataProps) => {
  const { companySegmentType } = useContext(GlobalDataContext)

  return (
    <Styles.Container width="100%" gap={3} flexWrap="wrap">
      <Box direction="column">
        <Text size="small" color="grey_3">
          Nome da empresa
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.name}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Identificação/CNPJ
        </Text>
        <Text size="small" fontWeight={500}>
          {docMask(provider?.taxId ?? '')}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Segmento
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.segment
            ? companySegmentType[provider?.segment]?.translate
            : 'Desconhecido'}
        </Text>
      </Box>
      {/* <Box direction="column">
        <Text size="small" color="grey_3">
          Email
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.email}
        </Text>
      </Box> */}
      <Box direction="column">
        <Text size="small" color="grey_3">
          Logradouro
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.address?.street
            ? provider?.address?.street + ', ' + provider?.address?.number
            : '--'}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Bairro
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.address ? provider?.address.district : '--'}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Cidade
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.address ? provider?.address.city : '--'}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Estado
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.address ? provider?.address.state : '--'}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          País
        </Text>
        <Text size="small" fontWeight={500}>
          {provider?.address ? provider?.address.country : '--'}
        </Text>
      </Box>
    </Styles.Container>
  )
}
